module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('grouped-bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "keys": _vm.keys
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Teams: Boundries")]), _vm._v(" "), _c('p', [_vm._v("This chart visualizes the IPL teams across all seasons based on")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Total Sixes Hit")]), _vm._v(" "), _c('li', [_vm._v("Total Fours Hit")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Royal Challengers Banglore appears to be the most explosive side in IPL\n        with highest number of sixes scored.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Mumbai Indians have scored the most fours for a IPL side.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f570c486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TeamsByBoundries.vue
// module id = 404
// module chunks = 1